<!-- Button -->
<button
    mat-icon-button
    [matTooltip]="''"
    (click)="toggleFullscreen()">
    <mat-icon [svgIcon]="'heroicons_outline:arrows-expand'"></mat-icon>
</button>
